import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { TaskGroup } from 'models/task-groups.model';
import { updateTaskGroup } from 'api/task-groups.service';

type MutationFnArgs = {
  id: string;
  taskGroup: TaskGroup;
};

export const useTaskGroupsUpdateQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: ({ id, taskGroup }: MutationFnArgs) =>
      updateTaskGroup(id, taskGroup),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taskGroups'] });
      toast.success('Group has been edited successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
